import {models as global} from './app';
import {models as auth} from './auth/auth';
import {models as newRequest} from './new-request/new-request';
import {models as common} from './common/common';
import {models as unSignedDocs} from './un-signed-docs/un-signed-docs';
import {models as myDocuments} from './my-documents/my-documents';
import {models as documentDetail} from './document-detail/document-detail';

const models = {
  global,
  auth,
  newRequest,
  common,
  unSignedDocs,
  myDocuments,
  documentDetail
}

export default models;
